import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ width = '100%', height = 500 }) => (
  <ContentLoader
    speed={2}
    style={{ width, height }}
    backgroundColor="#EEECEC"
  >
    <rect x="10%" y="30" rx="6" ry="6" width="80%" height="104" />
    <rect x="10%" y="140" rx="6" ry="6" width="80%" height="2" />
    <rect x="10%" y="150" rx="6" ry="6" width="80%" height="104" />
    <rect x="10%" y="264" rx="6" ry="6" width="80%" height="2" />
    <rect x="10%" y="274" rx="6" ry="6" width="80%" height="104" />
    <rect x="10%" y="388" rx="6" ry="6" width="80%" height="2" />
  </ContentLoader>
);

export default Loader;
